import * as React from 'react';
import {
  CorporateNavigationDropdownItemWindow,
  MenuState,
} from './CorporateNavigationDropdownItemWindow';
import styled from 'styled-components';

export interface Props {
  category: any;
  isOpenDropdown?: boolean;
  onClickDropdown?: any;
  level: number;
  navigationType: MenuState;
  byId: any;
}

function NavigationItems({
  category,
  onClickDropdown,
  level,
  navigationType,
  byId,
}: Props) {
  const { children } = category;
  // console.log({ category });

  return (
    <>
      <ItemWrapper>
        {level === 0 && (
          <CorporateNavigationDropdownItemWindow
            category={category}
            onClick={onClickDropdown}
            navigationType={navigationType}
            byId={byId}
          />
        )}
      </ItemWrapper>
    </>
  );
}

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export { NavigationItems as CorporateNavigationItems };
